const PLATFORM_URL =
  (import.meta.env['VITE_PLATFORM_URL'] as string | undefined) ||
  'http://localhost:7001';

export function LoginPage(): JSX.Element {
  const handleDiscordLogin = () => {
    window.location.href = `${PLATFORM_URL}/auth/discord`;
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={titleStyle}>MyTile</div>
        <div style={subtitleStyle}>Sign in to explore, build, and play.</div>
        <button style={discordBtnStyle} onClick={handleDiscordLogin}>
          <svg width="20" height="15" viewBox="0 0 71 55" fill="currentColor" style={{ marginRight: 10 }}>
            <path d="M60.1 4.9A58.5 58.5 0 0045.4.2a.2.2 0 00-.2.1 41 41 0 00-1.8 3.7 54 54 0 00-16.2 0A39 39 0 0025.4.3a.2.2 0 00-.2-.1A58.4 58.4 0 0010.5 5a.2.2 0 00-.1 0A59.7 59.7 0 00.3 45.4a.2.2 0 000 .2A58.9 58.9 0 0018 54.8a.2.2 0 00.3-.1 42.1 42.1 0 003.6-5.9.2.2 0 00-.1-.3 38.8 38.8 0 01-5.5-2.7.2.2 0 01 0-.4l1.1-.9a.2.2 0 01.2 0 42 42 0 0035.8 0 .2.2 0 01.2 0l1.1.9a.2.2 0 010 .3 36.4 36.4 0 01-5.5 2.7.2.2 0 00-.1.4 47.2 47.2 0 003.6 5.8.2.2 0 00.3.1 58.7 58.7 0 0017.8-9.2.2.2 0 000-.2C68 20.6 64.3 12.5 60.1 5a.2.2 0 00-.1 0zM23.7 37.3c-3.5 0-6.4-3.2-6.4-7.1s2.8-7.1 6.4-7.1c3.6 0 6.5 3.2 6.4 7.1 0 3.9-2.8 7.1-6.4 7.1zm23.6 0c-3.5 0-6.4-3.2-6.4-7.1s2.8-7.1 6.4-7.1c3.6 0 6.5 3.2 6.4 7.1 0 3.9-2.8 7.1-6.4 7.1z" />
          </svg>
          Sign in with Discord
        </button>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  height: '100vh',
  background: '#1e1f22',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif",
};

const cardStyle: React.CSSProperties = {
  background: '#2b2d31',
  border: '1px solid #3f4147',
  borderRadius: 12,
  padding: '48px 56px',
  textAlign: 'center',
  maxWidth: 400,
};

const titleStyle: React.CSSProperties = {
  fontSize: 32,
  fontWeight: 700,
  color: '#f2f3f5',
  marginBottom: 8,
};

const subtitleStyle: React.CSSProperties = {
  fontSize: 14,
  color: '#949ba4',
  marginBottom: 32,
};

const discordBtnStyle: React.CSSProperties = {
  background: '#5865f2',
  color: '#ffffff',
  border: 'none',
  borderRadius: 4,
  padding: '12px 24px',
  fontSize: 16,
  fontWeight: 600,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
};
